import React, { useState, useEffect } from "react";
import { PDFDocument } from "pdf-lib";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepContent from "@material-ui/core/StepContent";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { isEmpty, isUndefined, filter, isNumber } from 'lodash';
import SeparatePropertySection from "./SeparatePropertySection";
import SeparateProperty2ndSection from "./SeparateProperty2ndSection";
import { postData, successDescriptionOptionsData, postSecondTableData, getData } from './separateProperty.actions';
import Loader from "react-loader-spinner";
import { serverApi } from '../../../../../../global/globalFunctions';
import moment from 'moment';
import {
  getStates,
  getFormData
} from "../../../profileInformation/profileInformation.actions";
import {
  FormGroup,
  Label,
  Input,
  Row,
  Col,
  Collapse,
  CustomInput,
  Card,
  ModalBody,
  Modal,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  actionsContainer: {
    marginBottom: theme.spacing(2),
  },
  resetContainer: {
    padding: theme.spacing(3),
  },
}));

const SeparateProperty = (props) => {

  function getSteps() {
    return [
      "REAL ESTATE",
      "HOUSEHOLD FURNITURE,FURNISHINGS,APPLIANCES",
      "JEWELRY, ANTIQUE, ART, COIN COLLECTIONS, etc.",
      "VEHICLES, BOATS, TRAILERS",
      "SAVINGS ACCOUNTS",
      "CHECKING ACCOUNTS",
      "CREDIT UNION,OTHER DEPOSITORY ACCOUNTS",
      "CASH",
      "TAX REFUND",
      "LIFE INSURANCE WITH CASH SURRENDER OR LOAN VALUE",
      "STOCKS,BONDS,SECURED NOTES, MUTUAL FUNDS",
      "RETIREMENTS AND PENSIONS",
      "PROFIT-SHARING,IRAS, DEFERRED COMPENSATION, ANNUITIES",
      "ACCOUNTS RECEIVEABLE,UNSECURED NOTES",
      "PARTNERSHIP, OTHER BUSINESS INTERESTS",
      "OTHER ASSESTS",
      "STUDENT LOANS",
      "TAXES",
      "SUPPORT ARREARAGES",
      "LOANS-UNSECURED",
      "CREDIT CARDS",
      "OTHER DEBTS",
    ];

  }

  async function myFunction() {
    const existingPdfBytes = await fetch(`${serverApi}/Community-FL-160`, {
      headers: {
        Authorization: 'BEARER ' + window.localStorage.getItem("auth_id")
      },
    }).then((res) => res.arrayBuffer());
    var bytes = new Uint8Array(existingPdfBytes);
    const pdfDoc = await PDFDocument.load(bytes, { ignoreEncryption: true });
    const form = pdfDoc.getForm();

    const petitionerDetails = props.petitioner;
    const respondentDetails = props.respondent;
    const courtDetails = props.court;


    const petState = !isUndefined(petitionerDetails) && filter(props.states, state => state.state_id == petitionerDetails.state);
    const resState = !isUndefined(respondentDetails) && filter(props.states, state => state.state_id == respondentDetails.state);
    const courtState = !isUndefined(courtDetails) && filter(props.states, state => state.state_id == courtDetails.branch);


    if (props.petitionerCheck == 0) {
      form.getCheckBox("ch_p").check();
      !isUndefined(petitionerDetails) && form.getField("namep").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}`);
      !isEmpty(petState) && form.getField("state").setText(petState[0].state_name);
      !isUndefined(petitionerDetails) && form.getField("name").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}`);
      !isUndefined(petitionerDetails) && form.getField("zip").setText(petitionerDetails.zip);
      !isUndefined(petitionerDetails) && form.getField("telephone").setText(petitionerDetails.telephone);
      !isUndefined(petitionerDetails) && form.getField("email").setText(petitionerDetails.email);
      !isUndefined(petitionerDetails) && form.getField("sAddress").setText(petitionerDetails.streetAddress);
      !isUndefined(petitionerDetails) && form.getField("city").setText(petitionerDetails.city);

    } else {
      form.getCheckBox("ch_r").check();
      !isUndefined(respondentDetails) && form.getField("namep").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}`);
      !isEmpty(resState) && form.getField("state").setText(resState[0].state_name);
      !isUndefined(respondentDetails) && form.getField("name").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}`);
      !isUndefined(respondentDetails) && form.getField("zip").setText(respondentDetails.zip);
      !isUndefined(respondentDetails) && form.getField("telephone").setText(respondentDetails.telephone);
      !isUndefined(respondentDetails) && form.getField("email").setText(respondentDetails.email);
      !isUndefined(respondentDetails) && form.getField("sAddress").setText(respondentDetails.streetAddress);
      !isUndefined(respondentDetails) && form.getField("city").setText(respondentDetails.city);

    }

    !isUndefined(courtDetails) && form.getField("address").setText(courtDetails.courtStreetAddress);
    !isUndefined(courtDetails) && form.getField("mailing").setText(courtDetails.courtMailingAddress);
    !isUndefined(courtDetails) && form.getField("cityAndZip").setText(`${courtDetails.city}` + ` ` + `${courtDetails.zip}`);
    !isUndefined(courtDetails) && form.getField("superior").setText(courtDetails.county);
    !isUndefined(courtDetails) && form.getField("branch").setText(courtDetails.branchName);

    !isUndefined(respondentDetails) && form.getField("respondent").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}`);
    !isUndefined(petitionerDetails) && form.getField("petitioner").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}`);


    form.getField("caseNumber").setText(courtDetails.caseNumber.toString());
    form.getCheckBox("ch_separate").check();

    let totalGrossFairValue = 0;
    let totalAmountOfDebt = 0;
    let totalNetFairValue = 0;
    let totalPetitionerValue = 0;
    let totalRespondentValue = 0;


    let totalOwing = 0;
    let totalDebtPetitioner = 0;
    let totalDebtRespondent = 0;


    //REALSTATE
    // eslint-disable-next-line array-callback-return
    props.realEstateS.map((value, index) => {

      totalGrossFairValue = Number(totalGrossFairValue) + Number(value.gfmv);
      totalAmountOfDebt = Number(totalAmountOfDebt) + Number(value.aod);
      totalNetFairValue = Number(totalNetFairValue) + Number(value.nfmv);
      totalNetFairValue = Number(totalNetFairValue) + Number(value.nfmv);
      totalRespondentValue = Number(totalRespondentValue) + Number(value.pfdr);

      form.getField(`RED${index}`).setText(value.brief_desc);
      !isUndefined(value.date_acquired) && !isEmpty(value.date_acquired) && form.getField(`REDA${index}`).setText(value.date_acquired == "1947-01-01" ? "" : moment(value.date_acquired).format('l'));
      !isUndefined(value.gfmv) && form.getField(`REGF${index}`).setText(value.gfmv.toString());
      !isUndefined(value.aod) && form.getField(`READ${index}`).setText(value.aod.toString());
      !isUndefined(value.nfmv) && form.getField(`RENF${index}`).setText(value.nfmv.toString());
      !isUndefined(value.pfdp) && form.getField(`REP${index}`).setText(value.pfdp.toString());
      !isUndefined(value.pfdr) && form.getField(`RER${index}`).setText(value.pfdr.toString());
    });




    //HOUSEHOLD


    props.householdS.map((value, index) => {

      totalGrossFairValue = Number(totalGrossFairValue) + Number(value.gfmv);
      totalAmountOfDebt = Number(totalAmountOfDebt) + Number(value.aod);
      totalNetFairValue = Number(totalNetFairValue) + Number(value.nfmv);
      totalNetFairValue = Number(totalNetFairValue) + Number(value.nfmv);
      totalRespondentValue = Number(totalRespondentValue) + Number(value.pfdr);


      form.getField(`HOD${index}`).setText(value.brief_desc);
      !isUndefined(value.date_acquired) && !isEmpty(value.date_acquired) && form.getField(`HODA${index}`).setText(value.date_acquired == "1947-01-01" ? "" : moment(value.date_acquired).format('l'));
      !isUndefined(value.gfmv) && form.getField(`HOGF${index}`).setText(value.gfmv.toString());
      !isUndefined(value.aod) && form.getField(`HOAD${index}`).setText(value.aod.toString());
      !isUndefined(value.nfmv) && form.getField(`HONF${index}`).setText(value.nfmv.toString());
      !isUndefined(value.pfdp) && form.getField(`HOP${index}`).setText(value.pfdp.toString());
      !isUndefined(value.pfdr) && form.getField(`HOR${index}`).setText(value.pfdr.toString());
    });

    //JEWELARY  
    props.jewelaryS.map((value, index) => {

      totalGrossFairValue = Number(totalGrossFairValue) + Number(value.gfmv);
      totalAmountOfDebt = Number(totalAmountOfDebt) + Number(value.aod);
      totalNetFairValue = Number(totalNetFairValue) + Number(value.nfmv);
      totalNetFairValue = Number(totalNetFairValue) + Number(value.nfmv);
      totalRespondentValue = Number(totalRespondentValue) + Number(value.pfdr);

      form.getField(`JED${index}`).setText(value.brief_desc);
      !isUndefined(value.date_acquired) && !isEmpty(value.date_acquired) && form.getField(`JEDA${index}`).setText(value.date_acquired == "1947-01-01" ? "" : moment(value.date_acquired).format('l'));
      !isUndefined(value.gfmv) && form.getField(`JEGF${index}`).setText(value.gfmv.toString());
      !isUndefined(value.aod) && form.getField(`JEAD${index}`).setText(value.aod.toString());
      !isUndefined(value.nfmv) && form.getField(`JENF${index}`).setText(value.nfmv.toString());
      !isUndefined(value.pfdp) && form.getField(`JEP${index}`).setText(value.pfdp.toString());
      !isUndefined(value.pfdr) && form.getField(`JER${index}`).setText(value.pfdr.toString());
    });

    //VEHICLES
    props.vehiclesS.map((value, index) => {

      totalGrossFairValue = Number(totalGrossFairValue) + Number(value.gfmv);
      totalAmountOfDebt = Number(totalAmountOfDebt) + Number(value.aod);
      totalNetFairValue = Number(totalNetFairValue) + Number(value.nfmv);
      totalNetFairValue = Number(totalNetFairValue) + Number(value.nfmv);
      totalRespondentValue = Number(totalRespondentValue) + Number(value.pfdr);

      form.getField(`VED${index}`).setText(value.brief_desc);
      !isUndefined(value.date_acquired) && !isEmpty(value.date_acquired) && form.getField(`VEDA${index}`).setText(value.date_acquired == "1947-01-01" ? "" : moment(value.date_acquired).format('l'));
      !isUndefined(value.gfmv) && form.getField(`VEGF${index}`).setText(value.gfmv.toString());
      !isUndefined(value.aod) && form.getField(`VEAD${index}`).setText(value.aod.toString());
      !isUndefined(value.nfmv) && form.getField(`VENF${index}`).setText(value.nfmv.toString());
      !isUndefined(value.pfdp) && form.getField(`VEP${index}`).setText(value.pfdp.toString());
      !isUndefined(value.pfdr) && form.getField(`VER${index}`).setText(value.pfdr.toString());
    });

    //SAVING_ACCOUNTS             
    props.savingsS.map((value, index) => {

      totalGrossFairValue = Number(totalGrossFairValue) + Number(value.gfmv);
      totalAmountOfDebt = Number(totalAmountOfDebt) + Number(value.aod);
      totalNetFairValue = Number(totalNetFairValue) + Number(value.nfmv);
      totalNetFairValue = Number(totalNetFairValue) + Number(value.nfmv);
      totalRespondentValue = Number(totalRespondentValue) + Number(value.pfdr);


      form.getField(`SAD${index}`).setText(value.brief_desc);
      !isUndefined(value.date_acquired) && !isEmpty(value.date_acquired) && form.getField(`SADA${index}`).setText(value.date_acquired == "1947-01-01" ? "" : moment(value.date_acquired).format('l'));
      !isUndefined(value.gfmv) && form.getField(`SAGF${index}`).setText(value.gfmv.toString());
      !isUndefined(value.aod) && form.getField(`SAAD${index}`).setText(value.aod.toString());
      !isUndefined(value.nfmv) && form.getField(`SANF${index}`).setText(value.nfmv.toString());
      !isUndefined(value.pfdp) && form.getField(`SAP${index}`).setText(value.pfdp.toString());
      !isUndefined(value.pfdr) && form.getField(`SAR${index}`).setText(value.pfdr.toString());
    });

    //CHECKING_ACCOUNT
    props.checkingS.map((value, index) => {

      totalGrossFairValue = Number(totalGrossFairValue) + Number(value.gfmv);
      totalAmountOfDebt = Number(totalAmountOfDebt) + Number(value.aod);
      totalNetFairValue = Number(totalNetFairValue) + Number(value.nfmv);
      totalNetFairValue = Number(totalNetFairValue) + Number(value.nfmv);
      totalRespondentValue = Number(totalRespondentValue) + Number(value.pfdr);


      form.getField(`CHD${index}`).setText(value.brief_desc);
      !isUndefined(value.date_acquired) && !isEmpty(value.date_acquired) && form.getField(`CHDA${index}`).setText(value.date_acquired == "1947-01-01" ? "" : moment(value.date_acquired).format('l'));
      !isUndefined(value.gfmv) && form.getField(`CHGF${index}`).setText(value.gfmv.toString());
      !isUndefined(value.aod) && form.getField(`CHAD${index}`).setText(value.aod.toString());
      !isUndefined(value.nfmv) && form.getField(`CHNF${index}`).setText(value.nfmv.toString());
      !isUndefined(value.pfdp) && form.getField(`CHP${index}`).setText(value.pfdp.toString());
      !isUndefined(value.pfdr) && form.getField(`CHR${index}`).setText(value.pfdr.toString());
    });

    //CREDIT_UNION
    props.creditS.map((value, index) => {

      totalGrossFairValue = Number(totalGrossFairValue) + Number(value.gfmv);
      totalAmountOfDebt = Number(totalAmountOfDebt) + Number(value.aod);
      totalNetFairValue = Number(totalNetFairValue) + Number(value.nfmv);
      totalNetFairValue = Number(totalNetFairValue) + Number(value.nfmv);
      totalRespondentValue = Number(totalRespondentValue) + Number(value.pfdr);

      form.getField(`CRD${index}`).setText(value.brief_desc);
      !isUndefined(value.date_acquired) && !isEmpty(value.date_acquired) && form.getField(`CRDA${index}`).setText(value.date_acquired == "1947-01-01" ? "" : moment(value.date_acquired).format('l'));
      !isUndefined(value.gfmv) && form.getField(`CRGF${index}`).setText(value.gfmv.toString());
      !isUndefined(value.aod) && form.getField(`CRAD${index}`).setText(value.aod.toString());
      !isUndefined(value.nfmv) && form.getField(`CRNF${index}`).setText(value.nfmv.toString());
      !isUndefined(value.pfdp) && form.getField(`CRP${index}`).setText(value.pfdp.toString());
      !isUndefined(value.pfdr) && form.getField(`CRR${index}`).setText(value.pfdr.toString());
    });


    //CASH
    props.cashS.map((value, index) => {

      totalGrossFairValue = Number(totalGrossFairValue) + Number(value.gfmv);
      totalAmountOfDebt = Number(totalAmountOfDebt) + Number(value.aod);
      totalNetFairValue = Number(totalNetFairValue) + Number(value.nfmv);
      totalNetFairValue = Number(totalNetFairValue) + Number(value.nfmv);
      totalRespondentValue = Number(totalRespondentValue) + Number(value.pfdr);

      form.getField(`CAD${index}`).setText(value.brief_desc);
      !isUndefined(value.date_acquired) && !isEmpty(value.date_acquired) && form.getField(`CADA${index}`).setText(value.date_acquired == "1947-01-01" ? "" : moment(value.date_acquired).format('l'));
      !isUndefined(value.gfmv) && form.getField(`CAGF${index}`).setText(value.gfmv.toString());
      !isUndefined(value.aod) && form.getField(`CAAD${index}`).setText(value.aod.toString());
      !isUndefined(value.nfmv) && form.getField(`CANF${index}`).setText(value.nfmv.toString());
      !isUndefined(value.pfdp) && form.getField(`CAP${index}`).setText(value.pfdp.toString());
      !isUndefined(value.pfdr) && form.getField(`CAR${index}`).setText(value.pfdr.toString());
    });

    //TAxREFUND
    props.taxRefundS.map((value, index) => {

      totalGrossFairValue = Number(totalGrossFairValue) + Number(value.gfmv);
      totalAmountOfDebt = Number(totalAmountOfDebt) + Number(value.aod);
      totalNetFairValue = Number(totalNetFairValue) + Number(value.nfmv);
      totalNetFairValue = Number(totalNetFairValue) + Number(value.nfmv);
      totalRespondentValue = Number(totalRespondentValue) + Number(value.pfdr);

      form.getField(`TAD${index}`).setText(value.brief_desc);
      !isUndefined(value.date_acquired) && !isEmpty(value.date_acquired) && form.getField(`TADA${index}`).setText(moment(value.date_acquired == "1947-01-01" ? "" : value.date_acquired).format('l'));
      !isUndefined(value.gfmv) && form.getField(`TAGF${index}`).setText(value.gfmv.toString());
      !isUndefined(value.aod) && form.getField(`TAAD${index}`).setText(value.aod.toString());
      !isUndefined(value.nfmv) && form.getField(`TANF${index}`).setText(value.nfmv.toString());
      !isUndefined(value.pfdp) && form.getField(`TAP${index}`).setText(value.pfdp.toString());
      !isUndefined(value.pfdr) && form.getField(`TAR${index}`).setText(value.pfdr.toString());
    });

    //INSUNRACNE
    props.lifeInsuranceS.map((value, index) => {

      totalGrossFairValue = Number(totalGrossFairValue) + Number(value.gfmv);
      totalAmountOfDebt = Number(totalAmountOfDebt) + Number(value.aod);
      totalNetFairValue = Number(totalNetFairValue) + Number(value.nfmv);
      totalNetFairValue = Number(totalNetFairValue) + Number(value.nfmv);
      totalRespondentValue = Number(totalRespondentValue) + Number(value.pfdr);

      form.getField(`LID${index}`).setText(value.brief_desc);
      !isUndefined(value.date_acquired) && !isEmpty(value.date_acquired) && form.getField(`LIDA${index}`).setText(value.date_acquired == "1947-01-01" ? "" : moment(value.date_acquired).format('l'));
      !isUndefined(value.gfmv) && form.getField(`LIGF${index}`).setText(value.gfmv.toString());
      !isUndefined(value.aod) && form.getField(`LIAD${index}`).setText(value.aod.toString());
      !isUndefined(value.nfmv) && form.getField(`LINF${index}`).setText(value.nfmv.toString());
      !isUndefined(value.pfdp) && form.getField(`LIP${index}`).setText(value.pfdp.toString());
      !isUndefined(value.pfdr) && form.getField(`LIR${index}`).setText(value.pfdr.toString());
    });

    //STOCKS
    props.stocksS.map((value, index) => {

      totalGrossFairValue = Number(totalGrossFairValue) + Number(value.gfmv);
      totalAmountOfDebt = Number(totalAmountOfDebt) + Number(value.aod);
      totalNetFairValue = Number(totalNetFairValue) + Number(value.nfmv);
      totalNetFairValue = Number(totalNetFairValue) + Number(value.nfmv);
      totalRespondentValue = Number(totalRespondentValue) + Number(value.pfdr);


      form.getField(`STD${index}`).setText(value.brief_desc);
      !isUndefined(value.date_acquired) && !isEmpty(value.date_acquired) && form.getField(`STDA${index}`).setText(value.date_acquired == "1947-01-01" ? "" : moment(value.date_acquired).format('l'));
      !isUndefined(value.gfmv) && form.getField(`STGF${index}`).setText(value.gfmv.toString());
      !isUndefined(value.aod) && form.getField(`STAD${index}`).setText(value.aod.toString());
      !isUndefined(value.nfmv) && form.getField(`STNF${index}`).setText(value.nfmv.toString());
      !isUndefined(value.pfdp) && form.getField(`STP${index}`).setText(value.pfdp.toString());
      !isUndefined(value.pfdr) && form.getField(`STR${index}`).setText(value.pfdr.toString());
    });
    //RETIREMENT
    props.retirementsS.map((value, index) => {

      totalGrossFairValue = Number(totalGrossFairValue) + Number(value.gfmv);
      totalAmountOfDebt = Number(totalAmountOfDebt) + Number(value.aod);
      totalNetFairValue = Number(totalNetFairValue) + Number(value.nfmv);
      totalNetFairValue = Number(totalNetFairValue) + Number(value.nfmv);
      totalRespondentValue = Number(totalRespondentValue) + Number(value.pfdr);

      form.getField(`RETD${index}`).setText(value.brief_desc);
      !isUndefined(value.date_acquired) && !isEmpty(value.date_acquired) && form.getField(`RETDA${index}`).setText(value.date_acquired == "1947-01-01" ? "" : moment(value.date_acquired).format('l'));
      !isUndefined(value.gfmv) && form.getField(`RETGF${index}`).setText(value.gfmv.toString());
      !isUndefined(value.aod) && form.getField(`RETAD${index}`).setText(value.aod.toString());
      !isUndefined(value.nfmv) && form.getField(`RETNF${index}`).setText(value.nfmv.toString());
      !isUndefined(value.pfdp) && form.getField(`RETP${index}`).setText(value.pfdp.toString());
      !isUndefined(value.pfdr) && form.getField(`RETR${index}`).setText(value.pfdr.toString());
    });

    //PROFIT-SHARING
    props.profitS.map((value, index) => {

      totalGrossFairValue = Number(totalGrossFairValue) + Number(value.gfmv);
      totalAmountOfDebt = Number(totalAmountOfDebt) + Number(value.aod);
      totalNetFairValue = Number(totalNetFairValue) + Number(value.nfmv);
      totalNetFairValue = Number(totalNetFairValue) + Number(value.nfmv);
      totalRespondentValue = Number(totalRespondentValue) + Number(value.pfdr);

      form.getField(`PRD${index}`).setText(value.brief_desc);
      !isUndefined(value.date_acquired) && !isEmpty(value.date_acquired) && form.getField(`PRDA${index}`).setText(value.date_acquired == "1947-01-01" ? "" : moment(value.date_acquired).format('l'));
      !isUndefined(value.gfmv) && form.getField(`PRGF${index}`).setText(value.gfmv.toString());
      !isUndefined(value.aod) && form.getField(`PRAD${index}`).setText(value.aod.toString());
      !isUndefined(value.nfmv) && form.getField(`PRNF${index}`).setText(value.nfmv.toString());
      !isUndefined(value.pfdp) && form.getField(`PRP${index}`).setText(value.pfdp.toString());
      !isUndefined(value.pfdr) && form.getField(`PRR${index}`).setText(value.pfdr.toString());
    });

    //ACCOUNTS RECEIVEABLE
    props.accountsS.map((value, index) => {

      totalGrossFairValue = Number(totalGrossFairValue) + Number(value.gfmv);
      totalAmountOfDebt = Number(totalAmountOfDebt) + Number(value.aod);
      totalNetFairValue = Number(totalNetFairValue) + Number(value.nfmv);
      totalNetFairValue = Number(totalNetFairValue) + Number(value.nfmv);
      totalRespondentValue = Number(totalRespondentValue) + Number(value.pfdr);

      form.getField(`ACD${index}`).setText(value.brief_desc);
      !isUndefined(value.date_acquired) && !isEmpty(value.date_acquired) && form.getField(`ACDA${index}`).setText(value.date_acquired == "1947-01-01" ? "" : moment(value.date_acquired).format('l'));
      !isUndefined(value.gfmv) && form.getField(`ACGF${index}`).setText(value.gfmv.toString());
      !isUndefined(value.aod) && form.getField(`ACAD${index}`).setText(value.aod.toString());
      !isUndefined(value.nfmv) && form.getField(`ACNF${index}`).setText(value.nfmv.toString());
      !isUndefined(value.pfdp) && form.getField(`ACP${index}`).setText(value.pfdp.toString());
      !isUndefined(value.pfdr) && form.getField(`ACR${index}`).setText(value.pfdr.toString());
    });

    //partnership               
    props.partnershipS.map((value, index) => {

      totalGrossFairValue = Number(totalGrossFairValue) + Number(value.gfmv);
      totalAmountOfDebt = Number(totalAmountOfDebt) + Number(value.aod);
      totalNetFairValue = Number(totalNetFairValue) + Number(value.nfmv);
      totalPetitionerValue = Number(totalPetitionerValue) + Number(value.pfdp);
      totalRespondentValue = Number(totalRespondentValue) + Number(value.pfdr);

      form.getField(`PAD${index}`).setText(value.brief_desc);
      !isUndefined(value.date_acquired) && !isEmpty(value.date_acquired) && form.getField(`PADA${index}`).setText(value.date_acquired == "1947-01-01" ? "" : moment(value.date_acquired).format('l'));
      !isUndefined(value.gfmv) && form.getField(`PAGF${index}`).setText(value.gfmv.toString());
      !isUndefined(value.aod) && form.getField(`PAAD${index}`).setText(value.aod.toString());
      !isUndefined(value.nfmv) && form.getField(`PANF${index}`).setText(value.nfmv.toString());
      !isUndefined(value.pfdp) && form.getField(`PAP${index}`).setText(value.pfdp.toString());
      !isUndefined(value.pfdr) && form.getField(`PAR${index}`).setText(value.pfdr.toString());
    });

    //OTHER ASSET
    props.otherAssetsS.map((value, index) => {

      totalGrossFairValue = Number(totalGrossFairValue) + Number(value.gfmv);
      totalAmountOfDebt = Number(totalAmountOfDebt) + Number(value.aod);
      totalNetFairValue = Number(totalNetFairValue) + Number(value.nfmv);
      totalNetFairValue = Number(totalNetFairValue) + Number(value.nfmv);
      totalRespondentValue = Number(totalRespondentValue) + Number(value.pfdr);


      form.getField(`OTD${index}`).setText(value.brief_desc);
      !isUndefined(value.date_acquired) && !isEmpty(value.date_acquired) && form.getField(`OTDA${index}`).setText(value.date_acquired == "1947-01-01" ? "" : moment(value.date_acquired).format('l'));
      !isUndefined(value.gfmv) && form.getField(`OTGF${index}`).setText(value.gfmv.toString());
      !isUndefined(value.aod) && form.getField(`OTAD${index}`).setText(value.aod.toString());
      !isUndefined(value.nfmv) && form.getField(`OTNF${index}`).setText(value.nfmv.toString());
      !isUndefined(value.pfdp) && form.getField(`OTP${index}`).setText(value.pfdp.toString());
      !isUndefined(value.pfdr) && form.getField(`OTR${index}`).setText(value.pfdr.toString());
    });

    //CONTINUATION_Assets
    props.continuationAssetsS.map((value, index) => {

      totalGrossFairValue = Number(totalGrossFairValue) + Number(value.gfmv);
      totalAmountOfDebt = Number(totalAmountOfDebt) + Number(value.aod);
      totalNetFairValue = Number(totalNetFairValue) + Number(value.nfmv);
      totalNetFairValue = Number(totalNetFairValue) + Number(value.nfmv);
      totalRespondentValue = Number(totalRespondentValue) + Number(value.pfdr);

      !isUndefined(value.date_acquired) && !isEmpty(value.date_acquired) && form.getField(`ASDA${index}`).setText(value.date_acquired == "1947-01-01" ? "" : moment(value.date_acquired).format('l'));
      !isUndefined(value.gfmv) && form.getField(`ASGF${index}`).setText(value.gfmv.toString());
      !isUndefined(value.aod) && form.getField(`ASAD${index}`).setText(value.aod.toString());
      !isUndefined(value.nfmv) && form.getField(`ASNF${index}`).setText(value.nfmv.toString());
      !isUndefined(value.pfdp) && form.getField(`ASP${index}`).setText(value.pfdp.toString());
      !isUndefined(value.pfdr) && form.getField(`ASR${index}`).setText(value.pfdr.toString());
    });

    //TOTAL ASSETS

    form.getField("TASGF").setText(totalGrossFairValue.toString());
    form.getField("TASAD").setText(totalAmountOfDebt.toString());
    form.getField("TASNF").setText(totalNetFairValue.toString());
    form.getField("TASP").setText(totalPetitionerValue.toString());
    form.getField("TASR").setText(totalRespondentValue.toString());

    //STUDENT LOANS
    props.studentLoansS.map((value, index) => {

      totalOwing = Number(totalOwing) + Number(value.debts_total_owing);
      totalDebtPetitioner = Number(totalDebtPetitioner) + Number(value.debts_pdap);
      totalDebtRespondent = Number(totalDebtRespondent) + Number(value.debts_pdcr);

      form.getField(`STDE${index}`).setText(value.debt_description);
      !isUndefined(value.debts_date_incurred) && !isEmpty(value.debts_date_incurred) && form.getField(`STDI${index}`).setText(value.debts_date_incurred == "1947-01-01" ? "" : moment(value.debts_date_incurred).format('l'));
      !isUndefined(value.debts_total_owing) && form.getField(`STTO${index}`).setText(value.debts_total_owing.toString());
      !isUndefined(value.debts_pdap) && form.getField(`STDP${index}`).setText(value.debts_pdap.toString());
      !isUndefined(value.debts_pdcr) && form.getField(`STDR${index}`).setText(value.debts_pdcr.toString());
    });

    //TAX
    props.taxesS.map((value, index) => {

      totalOwing = Number(totalOwing) + Number(value.debts_total_owing);
      totalDebtPetitioner = Number(totalDebtPetitioner) + Number(value.debts_pdap);
      totalDebtRespondent = Number(totalDebtRespondent) + Number(value.debts_pdcr);

      form.getField(`TADE${index}`).setText(value.debt_description);
      !isUndefined(value.debts_date_incurred) && !isEmpty(value.debts_date_incurred) && form.getField(`TADI${index}`).setText(value.debts_date_incurred == "1947-01-01" ? "" : moment(value.debts_date_incurred).format('l'));
      !isUndefined(value.debts_total_owing) && form.getField(`TATO${index}`).setText(value.debts_total_owing.toString());
      !isUndefined(value.debts_pdap) && form.getField(`TADP${index}`).setText(value.debts_pdap.toString());
      !isUndefined(value.debts_pdcr) && form.getField(`TADR${index}`).setText(value.debts_pdcr.toString());
    });

    //support
    props.supportS.map((value, index) => {

      totalOwing = Number(totalOwing) + Number(value.debts_total_owing);
      totalDebtPetitioner = Number(totalDebtPetitioner) + Number(value.debts_pdap);
      totalDebtRespondent = Number(totalDebtRespondent) + Number(value.debts_pdcr);

      form.getField(`SUDE${index}`).setText(value.debt_description);
      !isUndefined(value.debts_date_incurred) && !isEmpty(value.debts_date_incurred) && form.getField(`SUDI${index}`).setText(value.debts_date_incurred == "1947-01-01" ? "" : moment(value.debts_date_incurred).format('l'));
      !isUndefined(value.debts_total_owing) && form.getField(`SUTO${index}`).setText(value.debts_total_owing.toString());
      !isUndefined(value.debts_pdap) && form.getField(`SUDP${index}`).setText(value.debts_pdap.toString());
      !isUndefined(value.debts_pdcr) && form.getField(`SUDR${index}`).setText(value.debts_pdcr.toString());
    });

    //loans
    props.loansS.map((value, index) => {

      totalOwing = Number(totalOwing) + Number(value.debts_total_owing);
      totalDebtPetitioner = Number(totalDebtPetitioner) + Number(value.debts_pdap);
      totalDebtRespondent = Number(totalDebtRespondent) + Number(value.debts_pdcr);

      form.getField(`LODE${index}`).setText(value.debt_description);
      !isUndefined(value.debts_date_incurred) && !isEmpty(value.debts_date_incurred) && form.getField(`LODI${index}`).setText(value.debts_date_incurred == "1947-01-01" ? "" : moment(value.debts_date_incurred).format('l'));
      !isUndefined(value.debts_total_owing) && form.getField(`LOTO${index}`).setText(value.debts_total_owing.toString());
      !isUndefined(value.debts_pdap) && form.getField(`LODP${index}`).setText(value.debts_pdap.toString());
      !isUndefined(value.debts_pdcr) && form.getField(`LODR${index}`).setText(value.debts_pdcr.toString());
    });

    //creditCards
    props.creditCardsS.map((value, index) => {

      totalOwing = Number(totalOwing) + Number(value.debts_total_owing);
      totalDebtPetitioner = Number(totalDebtPetitioner) + Number(value.debts_pdap);
      totalDebtRespondent = Number(totalDebtRespondent) + Number(value.debts_pdcr);

      form.getField(`CRDE${index}`).setText(value.debt_description);
      !isUndefined(value.debts_date_incurred) && !isEmpty(value.debts_date_incurred) && form.getField(`CRDI${index}`).setText(value.debts_date_incurred == "1947-01-01" ? "" : moment(value.debts_date_incurred).format('l'));
      !isUndefined(value.debts_total_owing) && form.getField(`CRTO${index}`).setText(value.debts_total_owing.toString());
      !isUndefined(value.debts_pdap) && form.getField(`CRDP${index}`).setText(value.debts_pdap.toString());
      !isUndefined(value.debts_pdcr) && form.getField(`CRDR${index}`).setText(value.debts_pdcr.toString());
    });

    //debts
    props.debtsS.map((value, index) => {

      totalOwing = Number(totalOwing) + Number(value.debts_total_owing);
      totalDebtPetitioner = Number(totalDebtPetitioner) + Number(value.debts_pdap);
      totalDebtRespondent = Number(totalDebtRespondent) + Number(value.debts_pdcr);

      form.getField(`OTDE${index}`).setText(value.debt_description);
      !isUndefined(value.debts_date_incurred) && !isEmpty(value.debts_date_incurred) && form.getField(`OTDI${index}`).setText(value.debts_date_incurred == "1947-01-01" ? "" : moment(value.debts_date_incurred).format('l'));
      !isUndefined(value.debts_total_owing) && form.getField(`OTTO${index}`).setText(value.debts_total_owing.toString());
      !isUndefined(value.debts_pdap) && form.getField(`OTDP${index}`).setText(value.debts_pdap.toString());
      !isUndefined(value.debts_pdcr) && form.getField(`OTDR${index}`).setText(value.debts_pdcr.toString());
    });

    //continuationDebts
    props.continuationDebtsS.map((value, index) => {

      totalOwing = Number(totalOwing) + Number(value.debts_total_owing);
      totalDebtPetitioner = Number(totalDebtPetitioner) + Number(value.debts_pdap);
      totalDebtRespondent = Number(totalDebtRespondent) + Number(value.debts_pdcr);

      !isUndefined(value.debts_date_incurred) && !isEmpty(value.debts_date_incurred) && form.getField(`OTHDI${index}`).setText(value.debts_date_incurred == "1947-01-01" ? "" : moment(value.debts_date_incurred).format('l'));
      !isUndefined(value.debts_total_owing) && form.getField(`OTHTO${index}`).setText(value.debts_total_owing.toString());
      !isUndefined(value.debts_pdap) && form.getField(`OTHP${index}`).setText(value.debts_pdap.toString());
      !isUndefined(value.debts_pdcr) && form.getField(`OTHR${index}`).setText(value.debts_pdcr.toString());
    });

    form.getField("TDETO").setText(totalOwing.toString());
    form.getField("TDEP").setText(totalDebtPetitioner.toString());
    form.getField("TDER").setText(totalDebtRespondent.toString());




    

    // form.flatten();
    const pdfBytes = await pdfDoc.save();
     const pdfDataUrl = URL.createObjectURL(
      new Blob([pdfBytes], { type: "application/pdf" })
    );
    window.open(pdfDataUrl, "_blank");
  }

  function saveByteArray(reportName, byte) {
    var blob = new Blob([byte], { type: "application/pdf" });
    var link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    var fileName = reportName;
    link.download = fileName;
    link.click();
  }

  const classes = useStyles();
  useEffect(() => {
    props.getData({
      divorce_id: parseInt(window.localStorage.getItem("divorce_id")),
      propertyType: 2,
    });
    props.getStates();
    !isEmpty(window.localStorage.getItem("divorce_id")) && props.getFormData({
      divorce_id: window.localStorage.getItem("divorce_id"),
    });

    props.successDescriptionOptionsData();
    handleShow();
  }, []);

  const [data, setData] = useState('');
  const [descriptionID, setDescriptionID] = useState('');
  const [activeStep, setActiveStep] = React.useState(0);

  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);
  const steps = getSteps();

  function getStepContent(step, props) {
    switch (step) {
      case 0:
        return <SeparatePropertySection
          data={props.realEstateS}
          descriptionId={1}
          handleDescriptionChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[0].asset_brief_description_id)
          }}
          handleDateAcquiredChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[0].asset_brief_description_id)
          }}
          handleGrossFairChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[0].asset_brief_description_id)
          }}
          handleAmountDebitChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[0].asset_brief_description_id)
          }}
          handleNetFairChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[0].asset_brief_description_id)
          }}
          handlePetitionerChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[0].asset_brief_description_id)
          }}
          handleRespondentChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[0].asset_brief_description_id)
          }} />;
      case 1:
        return <SeparatePropertySection
          data={props.householdS}
          descriptionId={2}
          handleDescriptionChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[1].asset_brief_description_id)
          }}
          handleDateAcquiredChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[1].asset_brief_description_id)
          }}
          handleGrossFairChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[1].asset_brief_description_id)
          }}
          handleAmountDebitChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[1].asset_brief_description_id)
          }}
          handleNetFairChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[1].asset_brief_description_id)
          }}
          handlePetitionerChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[1].asset_brief_description_id)
          }}
          handleRespondentChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[1].asset_brief_description_id)
          }} />;
      case 2:
        return <SeparatePropertySection
          data={props.jewelaryS}
          descriptionId={3}
          handleDescriptionChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[2].asset_brief_description_id)
          }}
          handleDateAcquiredChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[2].asset_brief_description_id)
          }}
          handleGrossFairChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[2].asset_brief_description_id)
          }}
          handleAmountDebitChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[2].asset_brief_description_id)
          }}
          handleNetFairChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[2].asset_brief_description_id)
          }}
          handlePetitionerChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[2].asset_brief_description_id)
          }}
          handleRespondentChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[2].asset_brief_description_id)
          }} />;
      case 3:
        return <SeparatePropertySection
          data={props.vehiclesS}
          descriptionId={4}
          handleDescriptionChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[3].asset_brief_description_id)
          }}
          handleDateAcquiredChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[3].asset_brief_description_id)
          }}
          handleGrossFairChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[3].asset_brief_description_id)
          }}
          handleAmountDebitChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[3].asset_brief_description_id)
          }}
          handleNetFairChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[3].asset_brief_description_id)
          }}
          handlePetitionerChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[3].asset_brief_description_id)
          }}
          handleRespondentChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[3].asset_brief_description_id)
          }} />;
      case 4:
        return <SeparatePropertySection
          data={props.savingsS}
          descriptionId={5}
          handleDescriptionChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[4].asset_brief_description_id)
          }}
          handleDateAcquiredChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[4].asset_brief_description_id)
          }}
          handleGrossFairChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[4].asset_brief_description_id)
          }}
          handleAmountDebitChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[4].asset_brief_description_id)
          }}
          handleNetFairChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[4].asset_brief_description_id)
          }}
          handlePetitionerChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[4].asset_brief_description_id)
          }}
          handleRespondentChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[4].asset_brief_description_id)
          }} />;
      case 5:
        return <SeparatePropertySection
          data={props.checkingS}
          descriptionId={6}
          handleDescriptionChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[5].asset_brief_description_id)
          }}
          handleDateAcquiredChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[5].asset_brief_description_id)
          }}
          handleGrossFairChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[5].asset_brief_description_id)
          }}
          handleAmountDebitChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[5].asset_brief_description_id)
          }}
          handleNetFairChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[5].asset_brief_description_id)
          }}
          handlePetitionerChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[5].asset_brief_description_id)
          }}
          handleRespondentChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[5].asset_brief_description_id)
          }} />;
      case 6:
        return <SeparatePropertySection
          data={props.creditS}
          descriptionId={7}
          handleDescriptionChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[6].asset_brief_description_id)
          }}
          handleDateAcquiredChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[6].asset_brief_description_id)
          }}
          handleGrossFairChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[6].asset_brief_description_id)
          }}
          handleAmountDebitChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[6].asset_brief_description_id)
          }}
          handleNetFairChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[6].asset_brief_description_id)
          }}
          handlePetitionerChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[6].asset_brief_description_id)
          }}
          handleRespondentChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[6].asset_brief_description_id)
          }} />;
      case 7:
        return <SeparatePropertySection
          data={props.cashS}
          descriptionId={8}
          handleDescriptionChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[7].asset_brief_description_id)
          }}
          handleDateAcquiredChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[7].asset_brief_description_id)
          }}
          handleGrossFairChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[7].asset_brief_description_id)
          }}
          handleAmountDebitChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[7].asset_brief_description_id)
          }}
          handleNetFairChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[7].asset_brief_description_id)
          }}
          handlePetitionerChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[7].asset_brief_description_id)
          }}
          handleRespondentChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[7].asset_brief_description_id)
          }} />;
      case 8:
        return <SeparatePropertySection
          data={props.taxRefundS}
          descriptionId={9}
          handleDescriptionChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[8].asset_brief_description_id)
          }}
          handleDateAcquiredChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[8].asset_brief_description_id)
          }}
          handleGrossFairChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[8].asset_brief_description_id)
          }}
          handleAmountDebitChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[8].asset_brief_description_id)
          }}
          handleNetFairChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[8].asset_brief_description_id)
          }}
          handlePetitionerChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[8].asset_brief_description_id)
          }}
          handleRespondentChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[8].asset_brief_description_id)
          }} />;
      case 9:
        return <SeparatePropertySection
          data={props.lifeInsuranceS}
          descriptionId={10}
          handleDescriptionChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[9].asset_brief_description_id)
          }}
          handleDateAcquiredChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[9].asset_brief_description_id)
          }}
          handleGrossFairChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[9].asset_brief_description_id)
          }}
          handleAmountDebitChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[9].asset_brief_description_id)
          }}
          handleNetFairChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[9].asset_brief_description_id)
          }}
          handlePetitionerChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[9].asset_brief_description_id)
          }}
          handleRespondentChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[9].asset_brief_description_id)
          }} />;
      case 10:
        return <SeparatePropertySection
          data={props.stocksS}
          descriptionId={11}
          handleDescriptionChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[10].asset_brief_description_id)
          }}
          handleDateAcquiredChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[10].asset_brief_description_id)
          }}
          handleGrossFairChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[10].asset_brief_description_id)
          }}
          handleAmountDebitChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[10].asset_brief_description_id)
          }}
          handleNetFairChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[10].asset_brief_description_id)
          }}
          handlePetitionerChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[10].asset_brief_description_id)
          }}
          handleRespondentChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[10].asset_brief_description_id)
          }} />;
      case 11:
        return <SeparatePropertySection
          data={props.retirementsS}
          descriptionId={12}
          handleDescriptionChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[11].asset_brief_description_id)
          }}
          handleDateAcquiredChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[11].asset_brief_description_id)
          }}
          handleGrossFairChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[11].asset_brief_description_id)
          }}
          handleAmountDebitChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[11].asset_brief_description_id)
          }}
          handleNetFairChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[11].asset_brief_description_id)
          }}
          handlePetitionerChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[11].asset_brief_description_id)
          }}
          handleRespondentChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[11].asset_brief_description_id)
          }} />;
      case 12:
        return <SeparatePropertySection
          data={props.profitS}
          descriptionId={13}
          handleDescriptionChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[12].asset_brief_description_id)
          }}
          handleDateAcquiredChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[12].asset_brief_description_id)
          }}
          handleGrossFairChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[12].asset_brief_description_id)
          }}
          handleAmountDebitChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[12].asset_brief_description_id)
          }}
          handleNetFairChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[12].asset_brief_description_id)
          }}
          handlePetitionerChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[12].asset_brief_description_id)
          }}
          handleRespondentChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[12].asset_brief_description_id)
          }} />;
      case 13:
        return <SeparatePropertySection
          data={props.accountsS}
          descriptionId={14}
          handleDescriptionChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[13].asset_brief_description_id)
          }}
          handleDateAcquiredChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[13].asset_brief_description_id)
          }}
          handleGrossFairChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[13].asset_brief_description_id)
          }}
          handleAmountDebitChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[13].asset_brief_description_id)
          }}
          handleNetFairChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[13].asset_brief_description_id)
          }}
          handlePetitionerChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[13].asset_brief_description_id)
          }}
          handleRespondentChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[13].asset_brief_description_id)
          }} />;
      case 14:
        return <SeparatePropertySection
          data={props.partnershipS}
          descriptionId={15}
          handleDescriptionChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[14].asset_brief_description_id)
          }}
          handleDateAcquiredChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[14].asset_brief_description_id)
          }}
          handleGrossFairChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[14].asset_brief_description_id)
          }}
          handleAmountDebitChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[14].asset_brief_description_id)
          }}
          handleNetFairChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[14].asset_brief_description_id)
          }}
          handlePetitionerChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[14].asset_brief_description_id)
          }}
          handleRespondentChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[14].asset_brief_description_id)
          }} />;
      case 15:
        return <SeparatePropertySection
          data={props.otherAssetsS}
          descriptionId={16}
          handleDescriptionChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[15].asset_brief_description_id)
          }}
          handleDateAcquiredChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[15].asset_brief_description_id)
          }}
          handleGrossFairChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[15].asset_brief_description_id)
          }}
          handleAmountDebitChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[15].asset_brief_description_id)
          }}
          handleNetFairChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[15].asset_brief_description_id)
          }}
          handlePetitionerChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[15].asset_brief_description_id)
          }}
          handleRespondentChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[15].asset_brief_description_id)
          }} />;
      case 16:
        return <SeparateProperty2ndSection
          data={props.studentLoansS}
          descriptionId={17}
          handleDescriptionChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[17].asset_brief_description_id)
          }}
          handleDateIncurredChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[17].asset_brief_description_id)
          }}
          handleTotalOwingChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[17].asset_brief_description_id)
          }}
          handlePetitionerChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[17].asset_brief_description_id)
          }}
          handleRespondentChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[17].asset_brief_description_id)
          }} />;
      case 17:
        return <SeparateProperty2ndSection
          data={props.taxesS}
          descriptionId={18}
          handleDescriptionChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[18].asset_brief_description_id)
          }}
          handleDateIncurredChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[18].asset_brief_description_id)
          }}
          handleTotalOwingChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[18].asset_brief_description_id)
          }}
          handlePetitionerChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[18].asset_brief_description_id)
          }}
          handleRespondentChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[18].asset_brief_description_id)
          }} />;
      case 18:
        return <SeparateProperty2ndSection
          data={props.supportS}
          descriptionId={19}
          handleDescriptionChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[19].asset_brief_description_id)
          }}
          handleDateIncurredChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[19].asset_brief_description_id)
          }}
          handleTotalOwingChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[19].asset_brief_description_id)
          }}
          handlePetitionerChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[19].asset_brief_description_id)
          }}
          handleRespondentChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[19].asset_brief_description_id)
          }} />;
      case 19:
        return <SeparateProperty2ndSection
          data={props.loansS}
          descriptionId={20}
          handleDescriptionChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[20].asset_brief_description_id)
          }}
          handleDateIncurredChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[20].asset_brief_description_id)
          }}
          handleTotalOwingChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[20].asset_brief_description_id)
          }}
          handlePetitionerChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[20].asset_brief_description_id)
          }}
          handleRespondentChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[20].asset_brief_description_id)
          }} />;
      case 20:
        return <SeparateProperty2ndSection
          data={props.creditCardsS}
          descriptionId={21}
          handleDescriptionChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[21].asset_brief_description_id)
          }}
          handleDateIncurredChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[21].asset_brief_description_id)
          }}
          handleTotalOwingChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[21].asset_brief_description_id)
          }}
          handlePetitionerChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[21].asset_brief_description_id)
          }}
          handleRespondentChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[21].asset_brief_description_id)
          }} />;
      case 21:
        return <SeparateProperty2ndSection
          data={props.debtsS}
          descriptionId={22}
          handleDescriptionChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[22].asset_brief_description_id)
          }}
          handleDateIncurredChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[22].asset_brief_description_id)
          }}
          handleTotalOwingChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[22].asset_brief_description_id)
          }}
          handlePetitionerChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[22].asset_brief_description_id)
          }}
          handleRespondentChange={(e) => {
            setData(e);
            setDescriptionID(props.descriptionOptions[22].asset_brief_description_id)
          }} />;

      default:
        return;
    }
  }



  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);

    if (activeStep < 16) {
      if (!isEmpty(data)) {
        let dataWithKeys = data.map(v => ({ ...v, divorce_id: window.localStorage.getItem("divorce_id"), propertyType: 2, assetBriefDescriptionId: descriptionID }))
        props.postData({
          divorce_id: window.localStorage.getItem("divorce_id"),
          data: dataWithKeys,
          assetBriefDescriptionId: descriptionID,

        });
        setData('');
      }
    }
    else {
      if (!isEmpty(data)) {
        let dataWithKeys = data.map(v => ({ ...v, divorce_id: window.localStorage.getItem("divorce_id"), propertyType: 2, assetBriefDescriptionId: descriptionID }))
        props.postSecondTableData({
          divorce_id: window.localStorage.getItem("divorce_id"),
          data: dataWithKeys,
          assetBriefDescriptionId: descriptionID,
        });
      }
      setData('');
    };
  }

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  return (
    <div className={classes.root}>
      {props.isFetchingGetDataS ? <div style={{ marginLeft: "42%", marginTop: "18%" }}>
        <Loader
          type="Puff"
          color="#00BFFF"
          height={120}
          width={120}
        />
      </div>
        :
        <div>
          <Stepper activeStep={activeStep} orientation="vertical"
            style={{
              fontStyle: "normal",
              fontFamily: "sans-serif",
              backgroundColor: "white",
              textAlign: "justify",
              textJustify: "inter-word",
              padding: "30px 70px"
            }}
          >
            {steps.map((label, index) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
                <StepContent>
                  <Typography>{getStepContent(index, props)}</Typography>
                  <div className={classes.actionsContainer}>
                    <div>
                      <Button
                        disabled={activeStep === 0}
                        onClick={handleBack}
                        className={classes.button}
                      >
                        Back
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleNext}
                        className={classes.button}
                      >
                        {activeStep === steps.length - 1 ? "Finish" : "Next"}
                      </Button>
                    </div>
                  </div>
                </StepContent>
              </Step>
            ))}
          </Stepper>
          {activeStep === steps.length && (
            <Paper square elevation={0} className={classes.resetContainer}>
              <Typography>All steps completed - you&apos;re finished</Typography>
              <div>
                <Button style={{ backgroundColor: "red", color: "white" }} onClick={handleReset} className={classes.button}>
                  Reset
                </Button>
                <Button style={{ backgroundColor: "#3f51b5", color: "white" }} onClick={handleBack} className={classes.button}>
                  Back
                </Button>
              </div>
            </Paper>
          )}
          <Button
            style={{ float: "right" }}
            variant="contained"
            color="primary"
            onClick={myFunction}
          >
            Print Form
          </Button>
        </div>}
      <Modal isOpen={show} style={{ marginTop: "200px", marginLeft: "46%" }}>
        <ModalHeader>
          Important:
        </ModalHeader>
        <ModalBody> You must answer each prompt, including the date, gross value, amount debit,
          net fair market value, petitioner and respondent. If there is
          no value or amount, put in $0.0. If you don't know the date,
          put your best estimate. Otherwise, you may have trouble with the program
          transferring your information to the sheet.
          <br />
          <br />
          Use the +/- to add or delete items. If you do not have the options to add more, the court form has run out
          of space. You will need to add a separate attachment. Watch your video
          tutorials for more details.
        </ModalBody>
        <ModalFooter>
          <Row style={{ marginLeft: "3px" }}>
            <Button
              style={{ width: "48%", marginRight: "2px", color: "white", backgroundColor: "Blue" }}
              onClick={handleClose}
            >
              OK
            </Button>
          </Row>
        </ModalFooter>
      </Modal>
    </div>
  );
}
const mapDispatchToProps = (dispatch) => {
  return {
    postData: (data) => dispatch(postData(data)),
    successDescriptionOptionsData: () => dispatch(successDescriptionOptionsData()),
    postSecondTableData: (data) => dispatch(postSecondTableData(data)),
    getData: (data) => dispatch(getData(data)),
    getFormData: (data) => dispatch(getFormData(data)),
    getStates: () => dispatch(getStates()),
  };
};

const mapStateToProps = (state, ownProps) => ({
  petitioner: state.ProfileInformationReducer.petitionerDetails,
  respondent: state.ProfileInformationReducer.respondentDetails,
  court: state.ProfileInformationReducer.court,
  realEstateS: state.separatePropertyReducer.realEstateS,
  householdS: state.separatePropertyReducer.householdS,
  jewelaryS: state.separatePropertyReducer.jewelaryS,
  vehiclesS: state.separatePropertyReducer.vehiclesS,
  savingsS: state.separatePropertyReducer.savingsS,
  checkingS: state.separatePropertyReducer.checkingS,
  creditS: state.separatePropertyReducer.creditS,
  cashS: state.separatePropertyReducer.cashS,
  taxRefundS: state.separatePropertyReducer.taxRefundS,
  lifeInsuranceS: state.separatePropertyReducer.lifeInsuranceS,
  stocksS: state.separatePropertyReducer.stocksS,
  retirementsS: state.separatePropertyReducer.retirementsS,
  profitS: state.separatePropertyReducer.profitS,
  accountsS: state.separatePropertyReducer.accountsS,
  partnershipS: state.separatePropertyReducer.partnershipS,
  otherAssetsS: state.separatePropertyReducer.otherAssetsS,
  continuationAssetsS: state.separatePropertyReducer.continuationAssetsS,
  studentLoansS: state.separatePropertyReducer.studentLoansS,
  taxesS: state.separatePropertyReducer.taxesS,
  supportS: state.separatePropertyReducer.supportS,
  loansS: state.separatePropertyReducer.loansS,
  creditCardsS: state.separatePropertyReducer.creditCardsS,
  debtsS: state.separatePropertyReducer.debtsS,
  continuationDebtsS: state.separatePropertyReducer.continuationDebtsS,
  descriptionOptions: state.separatePropertyReducer.descriptionOptions,
  isFetchingGetDataS: state.separatePropertyReducer.isFetchingGetDataS,
  states: state.ProfileInformationReducer.states,
  isFetchingStates: state.ProfileInformationReducer.isFetchingStates,
  petitionerCheck: state.ProfileInformationReducer.petitionerCheck,


});

export default connect(mapStateToProps, mapDispatchToProps)(SeparateProperty);
